/* wythout-accordion.js — the accordion's mirror source modes.
   Liquid gives one section no access to another section's (or another
   template's) blocks, so both modes clone already-rendered markup:

   - product FAQ mode (no data-faq-page attr): mirrors the FAQ drawer's
     panels on the current page — same content the chips and drawer render.
   - FAQ page mode (data-faq-page): fetches the sitewide FAQ page and clones
     its .faq-tabs__item question/answer pairs, so the FAQ page stays the
     single data store. Optional data-faq-category (matches a panel's
     category label, case-insensitive) and data-faq-limit.

   Cloned bodies keep their source classes so their inner richtext renders
   as authored. On a page with no source content the section hides itself —
   except in the Theme Editor, where it stays visible so the design-mode
   hint can explain why it's empty. */
(function () {
  'use strict';

  /* The <script> tag lives inside the section body, so a Theme-Editor section
     re-render re-inserts and re-runs it — without this the shopify:section:load
     listener below (and, in FAQ page mode, its fetch per list) would stack up
     with every edit. Guarded like the read-more scripts. */
  if (window.__wyAccordion) return;
  window.__wyAccordion = true;

  var CHEVRON =
    '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M3 5l4 4 4-4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* items: [{ q: string, body: Node|null }] */
  function buildRows(list, items) {
    var sectionEl = list.closest('.wy-expand');
    var designMode = window.Shopify && window.Shopify.designMode;

    if (!items.length) {
      list.hidden = true;
      if (sectionEl && !designMode) sectionEl.style.display = 'none';
      return;
    }

    var titleStyle = list.getAttribute('data-title-style') || '';
    var openFirst = list.getAttribute('data-open-first') === 'true';
    var frag = document.createDocumentFragment();
    var rendered = 0;

    items.forEach(function (item) {
      if (!item.q) return;

      var li = document.createElement('li');
      li.className = 'wy-expand__row';

      var details = document.createElement('details');
      details.className = 'wy-expand__details';
      if (openFirst && rendered === 0) details.open = true;

      var summary = document.createElement('summary');
      summary.className = 'wy-expand__summary';

      var title = document.createElement('span');
      title.className = 'wy-expand__title';
      if (titleStyle) title.setAttribute('style', titleStyle);
      title.textContent = item.q;

      var chevron = document.createElement('span');
      chevron.className = 'wy-expand__chevron';
      chevron.setAttribute('aria-hidden', 'true');
      chevron.innerHTML = CHEVRON;

      summary.appendChild(title);
      summary.appendChild(chevron);

      var rowPanel = document.createElement('div');
      rowPanel.className = 'wy-expand__panel';
      if (item.body) {
        var clone = item.body.cloneNode(true);
        clone.classList.add('wy-expand__body');
        rowPanel.appendChild(clone);
      }

      details.appendChild(summary);
      details.appendChild(rowPanel);
      li.appendChild(details);
      frag.appendChild(li);
      rendered++;
    });

    list.innerHTML = '';
    list.appendChild(frag);
    list.hidden = rendered === 0;
    if (sectionEl) {
      sectionEl.style.display = rendered === 0 && !designMode ? 'none' : '';
    }
  }

  function build(list) {
    var pageUrl = list.getAttribute('data-faq-page');

    if (pageUrl) {
      var category = (list.getAttribute('data-faq-category') || '').trim().toLowerCase();
      var limit = parseInt(list.getAttribute('data-faq-limit') || '0', 10) || 0;

      fetch(pageUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('FAQ page fetch failed: ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var seen = Object.create(null);
          var items = [];
          doc.querySelectorAll('.faq-tabs__panel').forEach(function (panel) {
            if (category) {
              var titleEl = panel.querySelector('.faq-tabs__panel-title');
              var label = titleEl ? titleEl.textContent.trim().toLowerCase() : '';
              if (label !== category) return;
            }
            panel.querySelectorAll('.faq-tabs__item').forEach(function (item) {
              var qEl = item.querySelector('.faq-tabs__q-text');
              var aEl = item.querySelector('.faq-tabs__a');
              if (!qEl) return;
              var q = qEl.textContent.trim();
              var key = q.toLowerCase();
              if (!q || seen[key]) return;
              seen[key] = true;
              items.push({ q: q, body: aEl });
            });
          });
          if (limit > 0) items = items.slice(0, limit);
          buildRows(list, items);
        })
        .catch(function () {
          buildRows(list, []);
        });
      return;
    }

    /* Product FAQ drawer mode — panels are on the current page. */
    var items = [];
    document.querySelectorAll('.faq-drawer__item').forEach(function (panel) {
      var q = panel.querySelector('.faq-drawer__q');
      var body = panel.querySelector('.faq-drawer__body');
      if (!q) return;
      items.push({ q: q.textContent.trim(), body: body });
    });
    buildRows(list, items);
  }

  function initAll() {
    document.querySelectorAll('[data-wy-faq-source]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  /* Editor reloads re-render sections in place — rebuild whenever any section
     (this one, or the section that owns the source content) reloads. */
  document.addEventListener('shopify:section:load', initAll);
})();
